import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectOutletActivationComponent } from './select-outlet-activation.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivateCodeFormModule } from '../../app-shared/components/activate-code-form/activate-code-form.module';
import { SelectOutletActivationRoutingModule } from './select-outlet-activation-routing.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [SelectOutletActivationComponent],
  imports: [
    CommonModule,
    SelectOutletActivationRoutingModule,
    TranslateModule,
    MatButtonModule,
    ActivateCodeFormModule,
    MatProgressSpinnerModule,
  ],
  exports: [SelectOutletActivationComponent],
})
export class SelectOutletActivationModule {}
